export default str => {
    let cpf = (str||'').replace(/\D/igm,'');
    if (11 >= cpf.length) {
        cpf = cpf.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/igm,'$1.$2.$3-$4');
    } else {
        cpf = cpf.substr(0,14);
        cpf = cpf.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/igm, '$1.$2.$3/$4-$5');
    }
    cpf = cpf.replace(/\D+$/igm,'');
    return cpf;
};